import moment from 'moment';
import { LanguageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isDefined } from '@philips-internal/oswald-ui-utils';
const Expressions = {
    JUST_NOW: 'tws.time.just-now',
    TODAY: 'tws.time.today',
    YESTERDAY: 'tws.time.yesterday',
};
const DAY_MONTH_YEAR_FORMAT = 'DD MMMM YYYY';
var TimeFormat;
(function (TimeFormat) {
    TimeFormat["TWELVE_HOURS"] = "hh:mm A";
    TimeFormat["TWENTY_FOUR_HOURS"] = "HH:mm";
})(TimeFormat || (TimeFormat = {}));
function getDateExpression(value) {
    const isToday = moment.utc(value).isSame(moment.utc(), 'day');
    const isYesterday = moment.utc(value).isSame(moment.utc().subtract(1, 'day'), 'day');
    if (isToday) {
        return Expressions.TODAY;
    }
    if (isYesterday) {
        return Expressions.YESTERDAY;
    }
    return moment.utc(value).local().format(DAY_MONTH_YEAR_FORMAT);
}
function getTimeExpression(value) {
    const dateA = moment.utc(value);
    const dateB = moment.utc().subtract(5, 'minutes');
    if (dateA >= dateB) {
        return Expressions.JUST_NOW;
    }
    const language = LanguageService.getCurrentLanguage();
    const { hour12 } = Intl.DateTimeFormat(language, { hour: 'numeric' }).resolvedOptions();
    const format = hour12 ? TimeFormat.TWELVE_HOURS : TimeFormat.TWENTY_FOUR_HOURS;
    const utcDateAsMoment = moment(dateA.toDate());
    return utcDateAsMoment.format(format);
}
function filterNotificationItems(items) {
    return items.filter((item) => isDefined(item.title));
}
function mapNotificationItems(items) {
    return items.map((item) => {
        const dateExpression = getDateExpression(item.date);
        const timeExpression = getTimeExpression(item.date);
        return {
            ...item,
            date: dateExpression,
            time: timeExpression,
        };
    });
}
function sortNotificationItems(items) {
    const copy = [...items];
    copy.sort((itemA, itemB) => {
        const dateA = moment.utc(itemA.date).unix();
        const dateB = moment.utc(itemB.date).unix();
        return dateB - dateA;
    });
    return copy;
}
export { filterNotificationItems, getDateExpression, getTimeExpression, mapNotificationItems, sortNotificationItems, };
//# sourceMappingURL=utils.js.map